import { Pagination } from '@innovyze/shared-utils';
import { STATUS_ENUM } from '@innovyze/stylovyze';

export enum IntegrationType {
	ArcGis = 'ArcGIS',
	Vapar = 'Vapar',
	ITPipes = 'ITPipes',
}

export enum IntegrationStepName {
	ArcGisSettings = 'arcgis-settings',
	VaparSettings = 'vapar-settings',
	ITPipesSettings = 'itpipes-settings',
	Edit = 'edit',
	EditVapar = 'editVapar',
	EditITPipes = 'editITPipes',
}

export interface IntegrationTableFormValues {
	integrationType?: IntegrationType;
}

export enum IntegrationStatus {
	Enabled = 'Enabled',
	Disabled = 'Disabled',
}

export interface IntegrationInfo {
	integrationType: IntegrationType;
	lastUpdatedData: string;

	username?: string;
	authenticated?: boolean;
	isEnabled?: boolean;
	toBeEnabled?: boolean;
	isValid?: boolean;
	connectedLayerCount?: number;
	lastImportTimestamp?: string;
	videosProcessed?: number;
}

export interface VaparIntegrationInfo extends IntegrationInfo {
	password?: string;

	isUKRegion?: boolean;
}

export interface ItPipesIntegrationInfo extends IntegrationInfo {
	apiKey?: string;
	portalUrl?: string;
}

export interface ArcGisSettingsFormValues {
	_id?: string;
	name?: string;
	syncSettings?: unknown;
	description?: string;
	integrationInfo?: IntegrationInfo;
	integrationTokenInfo?: CreateIntegrationParams;
	refreshTokenExpires?: string;
	ssl?: boolean;
	tokenDuration?: number;
	redirectUri?: string;
}

export interface VaparSettingsFormValues {
	_id?: string;
	name?: string;
	syncSettings?: unknown;
	description?: string;
	integrationInfo?: VaparIntegrationInfo;
	integrationTokenInfo?: CreateIntegrationParams;
	refreshTokenExpires?: string;
	ssl?: boolean;
	tokenDuration?: number;
	redirectUri?: string;
	enabledAiDefault?: boolean;
}

export interface ITPipesSettingsFormValues extends ArcGisSettingsFormValues {
	apiKey?: string;
	portalUrl?: string;
	integrationInfo?: ItPipesIntegrationInfo;
}
export interface ListIntegrationsParams {
	limit?: number;
	offset?: number;
	type?: string;
}

export interface CreateIntegrationParams {
	name?: string;
	type?: string;
	description?: string;
	clientId?: string;
	refreshTokenExpires?: string;
	username?: string;
	tokenExpires?: Date;
	portal?: string;
	ssl?: boolean;
	organizationId?: string;
	createdAt?: Date;
	token?: string;
	refreshToken?: string;
	isUKRegion?: boolean;
	isEnabled?: boolean;
	connectedLayerCount?: number;
	lastModifiedTimestamp?: Date;
	enabledAiDefault?: boolean;
	apiKey?: string;
	portalUrl?: string;
}

export interface Integration {
	_id: string;
	name: string;
	type: string;
	description: string;
	username?: string;
	isEnabled?: boolean;
	isValid?: boolean;
	lastModifiedTimestamp?: string;
	lastImportTimestamp?: string;
}
export interface EditIntegrationParams extends CreateIntegrationParams {
	_id?: string;
	isValid?: boolean;
	lastImportTimestamp?: string;
	videosProcessed?: number;
}

export interface PaginatedIntegrations {
	pagination?: Pagination;
	integrations?: Integration[];
	status: STATUS_ENUM;
}

export interface IntegrationsStoreState {
	initialized: boolean;
	integrationById: {
		status: STATUS_ENUM;
		integration?: EditIntegrationParams;
	};
	paginatedIntegrations?: PaginatedIntegrations;
	itpipesApiKeyValidation?: {
		status: STATUS_ENUM;
	};
}

export interface VAPARLoginParams {
	username: string;
	password: string;
}

export interface ValidateITPipesApiKeyPayload {
	portalUrl: string;
	apiKey: string;
}
